import { Injectable } from '@angular/core';
import { SecureStoragePlugin as Storage } from 'capacitor-secure-storage-plugin';

@Injectable()
export class StorageService {
  async get(key: string) {
    try {
      const result = await Storage.get({ key });
      return result.value;
    } catch {
      return null;
    }
  }

  async set(key: string, value: string) {
    try {
      const result = await Storage.set({ key, value });
      return result.value;
    } catch (e) {
      return false;
    }
  }

  async remove(key: string) {
    try {
      const result = await Storage.remove({ key });
      return result.value;
    } catch {
      return false;
    }
  }

  async clear() {
    try {
      const result = await Storage.clear();
      return result.value;
    } catch {
      return false;
    }
  }
}
